export default __webpack_public_path__ + "static/media/referral-empty.04322133.svg";